<template>
<div>
  <DataNavigation></DataNavigation>
  <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
  <div class="index_content">
    <Layout>
      <Sider width="208">
        <div class="right_column">
          <p class="top-tip">投资事件</p>
          <div class="keyword-input">
            <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
          </div>
          <div class="rigit_title">
            <span>筛选</span>
            <Dropdown placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
              <a href="javascript:void(0)">
                <span>{{screen_active}}</span>
                <Icon type="md-arrow-dropup" v-if="drop_val" />
                <Icon type="md-arrow-dropdown" v-else />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="rigit_content">
            <div class="screen_ul">
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '行业领域'">
                <div class="screen_tle" @click="screenTle.tag_arr = !screenTle.tag_arr">
                  <span>行业领域</span>
                  <Icon type="md-add" v-if="!screenTle.tag_arr" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.tag_arr">
                  <ul class="scr_attention">
                    <CheckboxGroup v-model="params.tag_arr" @on-change="handleChangeOption($event, 'tag_arr')">
                      <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                        <div class="scr_att_tle">
                          <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                          <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                          <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                        </div>
                        <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                          <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                            <span>{{item.name}} <template v-if="tagNum.length">({{item.id | dealName(tagNum, 'id', 'num', '0')}})</template></span>
                          </Checkbox>
                        </div>
                      </li>
                    </CheckboxGroup>
                  </ul>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '获投轮次'">
                <div class="screen_tle" @click="screenTle.round_id = !screenTle.round_id">
                  <span>获投轮次</span>
                  <Icon type="md-add" v-if="!screenTle.round_id" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.round_id">
                  <Checkbox v-model="checkAll.round_id" class="all_option" :disabled="checkAll.round_id" @on-change="handleCheckAll('round_id')">
                    <span>不限</span>
                  </Checkbox>
                  <CheckboxGroup v-model="params.round_id" @on-change="handleChangeOption($event, 'round_id')">
                    <Checkbox v-for="(item,index) in round" :label="item.id" :key="index" v-show="index < 10 || showAllRound">
                      <span>{{item.name}} <template v-if="roundNum.length">({{item.id | dealName(roundNum, 'round_id', 'num', '0')}})</template></span>
                    </Checkbox>
                  </CheckboxGroup>
                  <span class="more_sel" @click="showAllRound = !showAllRound">
                    <template v-if="!showAllRound">查看更多</template>
                    <template v-else>收起更多</template>
                  </span>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '地区选择'">
                <div class="screen_tle" @click="screenTle.address = !screenTle.address">
                  <span>地区选择</span>
                  <Icon type="md-add" v-if="!screenTle.address" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.address">
                  <RadioGroup v-model="params.demostic" vertical @on-change="handleChangeDemostic">
                    <Radio :label="null"><span>不限</span></Radio>
                    <Radio :label="0"><span>国外({{foreignNum}})</span></Radio>
                    <div class="sec_options" v-if="params.demostic == 0">
                      <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                        <span>全部</span>
                      </Checkbox>
                      <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                        <Checkbox v-for="(item,index) in foreign_country" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                          <span>{{item.name}}</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <span class="more_sel" @click="showAllAddress = !showAllAddress">
                        <template v-if="!showAllAddress">查看更多</template>
                        <template v-else>收起更多</template>
                      </span>
                    </div>
                    <Radio :label="1" class="bro"><span>国内({{chinaNum}})</span></Radio>
                    <div class="sec_options" v-if="params.demostic == 1">
                      <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                        <span>全部</span>
                      </Checkbox>
                      <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                        <Checkbox v-for="(item,index) in city" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                          <span>{{item.name}}</span>
                        </Checkbox>
                      </CheckboxGroup>
                      <span class="more_sel" @click="showAllAddress = !showAllAddress">
                        <template v-if="!showAllAddress">查看更多</template>
                        <template v-else>收起更多</template>
                      </span>
                    </div>
                  </RadioGroup>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '获投时间'">
                <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                  <span>获投时间</span>
                  <Icon type="md-add" v-if="!screenTle.time" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.time">
                  <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                      <span>{{item}} <template v-if="yearNum.length">({{item | dealName(yearNum, 'year', 'num', '0')}})</template></span>
                    </Radio>
                    <Radio label="zdy"><span>自定义</span></Radio>
                  </RadioGroup>
                  <div class="zdy_time" v-if="selTime == 'zdy'">
                    <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                  </div>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '币种选择'">
                <div class="screen_tle" @click="screenTle.unit_id = !screenTle.unit_id">
                  <span>币种选择</span>
                  <Icon type="md-add" v-if="!screenTle.unit_id" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.unit_id">
                  <RadioGroup v-model="params.unit_id" vertical @on-change="clearGetList">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio :label="1"><span>人民币</span></Radio>
                    <Radio :label="3"><span>美元</span></Radio>
                    <Radio :label="9"><span>港币</span></Radio>
                  </RadioGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sider>
      <Content>
        <div class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span>
          <Dropdown @on-click="haddleChangeSort">
            <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
          <div class="sel_tle">已选条件</div>
          <div class="sel_cnt">
            <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
              <Icon type="md-close" />
            </span>
          </div>
          <div class="sel_clear">
            <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div class="list_div">
          <Table :columns="listColumns" :data="listData"></Table>
          <SearchPrompt v-if="haveOption && haveOption.length > 0 && !isVIP  && listData.length == 5 && total > 5"></SearchPrompt>
          <template v-else>
            <div class="page clear" v-if="total > 10">
              <Page :current="params.page" :total="total" :page-size="10" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
            </div>
          </template>
          <Spin fix v-if="listLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </Content>
    </Layout>
  </div>
</div>
</template>

<script>
import {
  eventList,
  eventNum,
  tagEventNum
} from '../../service'
import {
  idxOf,
  remove,
  removeArrObj
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import Nothing from '@/components/Nothing.vue'
import DataNavigation from './components/DataNavigation.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import SearchPrompt from './components/SearchPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    Nothing,
    DataNavigation,
    VipPrompt,
    SearchPrompt
  },
  data() {
    return {
      listName: '投资事件',
      listColumns: [{
          title: '公司名称',
          width: 190,
          render: (h, params) => {
            return h('div', {
              class: {
                company: true
              }
            }, [
              h('div', {
                class: {
                  logo_img: true
                },
                on: {
                  click: () => {
                    this.goEntityDetail(params.row.entity_uid, params.row.type)
                  }
                },
              }, [
                h('img', {
                  attrs: {
                    src: filter.logo_show(params.row.logo_path)
                  }
                })
              ]),
              h('div', {
                class: {
                  company_name: true
                }
              }, [
                h('p', [
                  h('a', {
                    on: {
                      click: () => {
                        this.goEntityDetail(params.row.entity_uid, params.row.type)
                      }
                    }
                  }, params.row.short_name)
                ]),
              ])
            ])
          }
        },
        // {
        //   title: '行业领域',
        //   width: 180,
        //   render: (h, params) => {
        //     if (params.row.entity_tags && params.row.entity_tags.length > 0) {
        //       let entity_tags = []
        //       params.row.entity_tags.map((a, index) => {
        //         entity_tags.push(h('span', filter.deal(a, 'dynview_tag')))
        //         if (index < params.row.entity_tags.length - 1) entity_tags.push(h('span', '、'))
        //       })
        //       return h('div', {
        //         class: {
        //           'dec-clamp': true
        //         }
        //       }, entity_tags)
        //     } else {
        //       return h('span', '--')
        //     }
        //   }
        // },
        {
          title: '简要介绍',
          width: 180,
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.empty(params.row.description))
          }
        },
        {
          title: '地区',
          width: 120,
          render: (h, params) => {
            return h('span', filter.addressDeal(params.row.address_id, '2'))
          }
        },
        {
          title: '获投轮次',
          width: 100,
          render: (h, params) => {
            return h('span', filter.deal(params.row.round_id, 'round'))
          }
        },
        {
          title: '时间',
          width: 100,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.event_time))
          }
        },
        {
          title: '金额',
          width: 100,
          render: (h, params) => {
            return h('span', filter.amountPrecise(
              params.row.amount,
              params.row.unit_id,
              params.row.precise
            ))
          }
        },
        {
          title: '投资方',
          minWidth: 120,
          render: (h, params) => {
            if (params.row.tzf && params.row.tzf.length > 0) {
              let tzf = []
              params.row.tzf.map((a, index) => {
                if (a.entity_type != '2') {
                  tzf.push(h('a', {
                    on: {
                      click: () => {
                        this.goEntityDetail(a.entity_uid, a.entity_type)
                      }
                    }
                  }, a.entity_name))
                } else {
                  tzf.push(h('span', a.people_name))
                }
                if (index < params.row.tzf.length - 1) tzf.push(h('span', '、'))
              })
              return h('div', {
                class: {
                  'dec-clamp': true
                }
              }, tzf)
            } else {
              return h('span', '未透露')
            }
          }
        }
      ],
      params: {
        round_id: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        type: '0',
        e_time: '',
        user_key: '',
        tag_arr: [],
        keyword: '',
        page: 1,
        sort_type: 0,
        unit_id: ''
      },
      screen_dropdown: ['全部', '行业领域', '获投轮次', '地区选择', '获投时间', '币种选择'],
      //筛选条件是否展开
      screenTle: {
        tag_arr: false,
        round_id: false,
        address: false,
        time: false,
        unit_id: false
      },
      //获投轮次 相关变量
      //不限
      checkAll: {
        round_id: true,
        address_id: true,
      },
      showAllRound: false,
      showAllTag: false,

      chinaNum: 0,
      foreignNum: 0,
      provinceNum: [],
      roundNum: [],
      yearNum: [],
      tagNum: [],
      sort_id: 0,
      sort_list: [
        {id: 0, name: '获投时间倒序'},
        {id: 1, name: '获投时间正序'},
        {id: 2, name: '获投金额降序'},
        {id: 3, name: '获投金额升序'}
      ],
      position_id: '9'
    }
  },
  computed: {
    round() {
      return this.$store.state.round
    },
    haveOption() {
      let optionRound = [],
        optionTag = [],
        optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionAddressId = [],
        optionKeyWord = [],
        optionDemostic = [],
        optionUnit = []

      this.params.tag_arr.map((a) => {
        optionTag.push({
          type: 'tag_arr',
          name: filter.dealName(a, this.hot_tag_map),
          value: a
        })
      })

      this.params.round_id.map((a) => {
        optionRound.push({
          type: 'round_id',
          name: filter.deal(a, 'round'),
          value: a
        })
      })
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      if (this.params.demostic !== null) {
        optionDemostic = {
          type: 'demostic',
          name: this.params.demostic == 0 ? '国外' : '国内',
          value: this.params.demostic
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      this.params.address_id.map((a) => {
        optionAddressId.push({
          type: 'address_id',
          name: filter.deal(a, 'address'),
          value: a
        })
      })
      if (this.params.unit_id !== '') {
        optionUnit = {
          type: 'unit_id',
          name: filter.deal(this.params.unit_id, 'unit'),
          value: this.params.unit_id
        }
      }

      return [].concat(
        optionRound,
        optionTag,
        optionYear,
        optionStart,
        opitonEnd,
        optionKeyWord,
        optionDemostic,
        optionAddressId,
        optionUnit
      )
    }
  },
  methods: {
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if(this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if(this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await eventList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        tag_arr: [],
        round_id: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        user_key: '',
        keyword: '',
        type: '0',
        unit_id: ''
      }
      this.checkAll = {
        tag_arr: true,
        round_id: true,
        address: true,
        time: true
      }
      this.checkAllRound = true
      this.selTime = ''
      this.search_ipt = ''
      this.params.page = 1
      this.getEntityList()
    },
    /**
     * 筛选个数
     */
    async getCount() {
      let res = await eventNum((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'chinaNum', res.china)
        this.$set(this.$data, 'foreignNum', res.foreign)
        this.$set(this.$data, 'provinceNum', res.province)
        this.$set(this.$data, 'roundNum', res.round)
        this.$set(this.$data, 'yearNum', res.year)
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 产业领域数量计算-投融资/并购
     */
    async getTagNum(t_arr) {
      let res = await tagEventNum({
        type: 0,
        tag_arr: t_arr
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'tagNum', res.res)
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    if (this.$store.state.even_params != '') {
      this.params = { ...this.$store.state.even_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    this.getMeta()
    this.getEntityList()
    this.getCount()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateEvenParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
</style>
